import { jsx as _jsx } from "react/jsx-runtime";
import { capitalize } from '../../../utils/capitalize-string';
import NOB from '../../../constants/language-strings';
import Status, { COMPLETE_WITHOUT_CODE, CANCELLED } from '../../../constants/status-codes';
import { getHours, getMinutes } from '../../../utils/time-utils/time-calculator';
import styled from 'styled-components';
import { setStatusTimeDiv } from './set-status-time-div';
const StatusTime = styled.span `
  max-width: 140px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
`;
export const setStatusTimeValue = (workOrder, filteredWorkOrderStatus, isPastDue) => {
    const timeText = `${NOB.WORKORDER_LIST.TIME_ESTIMATE}: ${getHours(workOrder.totalTimeEstimate)} ${getMinutes(workOrder.totalTimeEstimate)}`;
    let workOrderStatus = timeText;
    if (filteredWorkOrderStatus.includes(COMPLETE_WITHOUT_CODE)) {
        workOrderStatus = (_jsx(StatusTime, { children: capitalize(filteredWorkOrderStatus) }));
    }
    else if (filteredWorkOrderStatus === CANCELLED) {
        workOrderStatus = setStatusTimeDiv(filteredWorkOrderStatus, timeText, true, workOrder.serviceDate, isPastDue);
    }
    else if (Status.ALLOCATED.includes(workOrder.status)) {
        const stringToShow = `kl.${workOrder.timeSlot}`;
        workOrderStatus = setStatusTimeDiv(stringToShow, timeText, false, workOrder.serviceDate, isPastDue);
    }
    else if (Status.TRAVELING.includes(workOrder.status)) {
        workOrderStatus = setStatusTimeDiv(NOB.WORKORDER_LIST.DRIVESTARTED, timeText, true, workOrder.serviceDate, isPastDue);
    }
    else if (Status.ON_SITE.includes(workOrder.status)) {
        workOrderStatus = setStatusTimeDiv(NOB.WORKORDER_LIST.WORKSTARTED, timeText, true, workOrder.serviceDate, isPastDue);
    }
    return workOrderStatus;
};
